import { connect } from 'react-redux';
import OneTimeEventForm from './OneTimeEventForm';
import State from '../../../../models';

const mapStateToProps = ({ calendar: { loading } }: State) => ({
  loading,
});

export default connect(mapStateToProps)(OneTimeEventForm);
